import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';
import { BrowserRouter, Route } from 'react-router-dom';
import ShowPage from './components/ShowPage.jsx';
import ReactDOM, { render } from 'react-dom';

class App extends Component {

  render() {
    return (
      <Provider store={store}>
        <Route path="/" component={ShowPage} />
      </Provider>
    );
  }
}

let showPage = document.getElementById('show-page');

if (showPage) {
  render(
    <BrowserRouter>
      <App/>
    </BrowserRouter>,
    showPage
  );
}